import { mapGqlEntryBase, mapGqlRichText } from './gqlMapUtils'

export function mapFaqGqlItem(item) {
  if (!item) {
    return null
  }

  return {
    ...mapGqlEntryBase(item, 'wwwFaq'),
    question: item.question ?? null,
    answer: mapGqlRichText(item.answer) ?? item.answer ?? null,
    isFaqEnabled: item.isFaqEnabled ?? null,
    order: item.order ?? null,
  }
}

export function mapFaqGql(items = []) {
  return items.filter(Boolean).map(mapFaqGqlItem)
}
